import { SR_API_ACTION_APARTMENT_LOCATOR_SUBMIT_APARTMENT_LEASE } from 'api/actionTypes';

export default function submitApartmentLease({ state, apiClient }, apartmentLease) {
  return apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_LOCATOR_SUBMIT_APARTMENT_LEASE,
    state: state,
    payload: {
      apartmentLease,
    },
    onSuccess(createdApartmentLease) {
      state.set(
        ['apartmentLocator', 'apartmentLeasesByUserId', createdApartmentLease.renterUserId],
        createdApartmentLease,
      );
    },
  });
}
